//DEV
const settings = {
   token: "20f8bc8a1792ee389530cbc709cb87a0a5473b6c",
   apiRoot: "https://stringsizer.western.it/api"
}
//PROD
// const settings = {
//    token: "20f8bc8a1792ee389530cbc709cb87a0a5473b6c",
//    apiRoot: "https://stringsizer.western.it/api"
// }
export default settings;
export const { token, apiRoot } = settings;